import type { UserRole } from '@mss_creator/shared';
import { FlagsSection } from './flags-section';
import { McpAccessSection } from './mcp-access-section';
import { RoleOverrideRow } from './role-override-row';
import { SettingSection } from './setting-section';

interface SystemTabProps {
  /** `user.role`, never the simulated role. */
  realRole: UserRole;
}

/**
 * The "Génération & système" tab, split by scope: the simulated role (this
 * browser) for every PMS role, then the deployment-wide flags for a real
 * `pms_admin` only. A `pms_user` sees no trace of the flags, not even read-only.
 * The « Accès MCP » section comes last: it concerns the account, not the
 * deployment, and follows the same rule (real role, never the simulated one).
 */
export function SystemTab({ realRole }: SystemTabProps) {
  return (
    <div>
      <SettingSection
        title="Ce navigateur"
        where="Ne change que ce que vous voyez, sur ce navigateur."
      >
        <RoleOverrideRow realRole={realRole} />
      </SettingSection>
      {realRole === 'pms_admin' && <FlagsSection />}
      {realRole === 'pms_admin' && <McpAccessSection />}
    </div>
  );
}
